var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_473_121)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.5,
    height: 16,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.136,
    cy: 4.20798,
    r: 1.056,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.376 4.15998C12.376 4.71668 12.328 5.49598 11.656 5.21598C11.08 4.97598 10.888 4.71668 10.888 4.15998C10.888 3.60327 11.5299 3.15198 11.848 3.15198C12.1661 3.15198 12.376 3.60327 12.376 4.15998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.088,
    cy: 4.256,
    r: 1.8816,
    stroke: "black",
    strokeWidth: 0.7488
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.024 12.4639L2.55267 12.3764C2.23026 12.3726 1.92 12.2528 1.67873 12.0389L1.5482 11.9232C1.21705 11.6296 1.09779 11.1641 1.24698 10.7475V10.7475C1.3455 10.4724 1.551 10.2488 1.81681 10.1274L4.05813 9.10388",
    stroke: "black",
    strokeWidth: 0.7488
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.63199 10.976L5.48314 11.0177C5.76742 11.0218 6.05014 10.9748 6.3178 10.879L6.80506 10.7044C7.1731 10.5726 7.46161 10.2812 7.58968 9.91179V9.91179C7.67459 9.66691 7.68384 9.40215 7.61624 9.15194L7.5741 8.99598C7.48407 8.66273 7.27915 8.37202 6.99555 8.1752V8.1752C6.7848 8.02894 6.53931 7.94064 6.28368 7.91914L5.53263 7.85596H4.62915",
    stroke: "black",
    strokeWidth: 0.7488
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.592 7.75989L8.59023 8.38399C8.39599 8.505 8.22758 8.6632 8.09468 8.8495L7.97772 9.01346C7.81146 9.24651 7.73441 9.53152 7.7606 9.8166V9.8166C7.79543 10.1956 8.00878 10.5354 8.33507 10.7314L9.16 11.227L10.6 12.0344L11.08 12.2719",
    stroke: "black",
    strokeWidth: 0.7488
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.888 12.2719L13.672 12.3679",
    stroke: "black",
    strokeWidth: 0.672
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.72 10.1119L2.29375 9.21386C2.64585 8.66274 3.0659 8.15813 3.544 7.7119V7.7119L4.024 7.2799L4.552 6.8959V6.8959C4.77568 6.70417 5.01344 6.5295 5.26327 6.37336L6.04 5.8879L7.096 5.3599L7.912 4.9759L8.728 4.6879L9.41114 4.47217C9.56282 4.42428 9.72094 4.3999 9.88 4.3999V4.3999",
    stroke: "black",
    strokeWidth: 0.672
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.92799 9.87186L11.0931 9.15217C11.9394 8.62942 12.8618 8.24138 13.8272 8.00193L15.3856 7.61542C15.4028 7.61116 15.4205 7.609 15.4382 7.609V7.609C15.5704 7.609 15.6723 7.49246 15.6546 7.36144L15.5248 6.39852C15.5108 6.29464 15.4816 6.1934 15.4381 6.09804L15.259 5.70538C15.2072 5.59181 15.1457 5.48292 15.0752 5.3799V5.3799C14.9319 5.17044 14.753 4.98769 14.5466 4.83992L14.5345 4.83123C14.4435 4.76602 14.3477 4.70768 14.248 4.65668L14.1213 4.59186",
    stroke: "black",
    strokeWidth: 0.7488,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.312 10.2559L11.368 10.8799",
    stroke: "black",
    strokeWidth: 0.7488,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.656 10.9128L12.1907 10.9422C12.5864 10.9639 12.958 11.1396 13.2258 11.4318L13.2443 11.452C13.3053 11.5185 13.3589 11.5913 13.4043 11.6692V11.6692C13.5168 11.8622 13.576 12.0814 13.576 12.3047V12.368",
    stroke: "black",
    strokeWidth: 0.7488,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.656 11.312L11.176 11.216",
    stroke: "#E5E5E5",
    strokeWidth: 0.048,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.4247,
    cy: 11.3229,
    rx: 0.24,
    ry: 0.0670849,
    transform: "rotate(19.3848 11.4247 11.3229)",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27999 11.2641C6.27999 11.2641 7.528 10.533 7.624 10.5441C7.72 10.5551 8.536 11.2641 8.536 11.2641",
    stroke: "black",
    strokeWidth: 0.048,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.48 10.5439L8.93493 11.3359H6.02508L7.48 10.5439Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.528,
    y: 10.448,
    width: 0.288,
    height: 0.288,
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_473_121"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.5,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeap);
export default __webpack_public_path__ + "static/media/leap.40ed5867a1ddf187bde68063a0d9b8ed.svg";
export { ForwardRef as ReactComponent };